/* Flora & Fire — Global JS
   Shared utilities and base custom elements. */

class FFElement extends HTMLElement {
  constructor() {
    super();
  }

  qsa(selector) {
    return this.querySelectorAll(selector);
  }

  qs(selector) {
    return this.querySelector(selector);
  }
}

/* ========================================
   Cart API
   ======================================== */

const CartAPI = {
  async get() {
    const res = await fetch('/cart.js');
    return res.json();
  },

  async add(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) throw new Error('Failed to add to cart');
    return res.json();
  },

  async update(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
    if (!res.ok) throw new Error('Failed to update cart');
    return res.json();
  },

  async change(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    if (!res.ok) throw new Error('Failed to change cart');
    return res.json();
  },
};

/* ========================================
   Cart State (event bus)
   ======================================== */

document.addEventListener('cart:updated', (e) => {
  const count = e.detail.item_count;
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    el.textContent = count;
    el.hidden = count === 0;
  });
});

function dispatchCartUpdate(cart) {
  document.dispatchEvent(
    new CustomEvent('cart:updated', { detail: cart })
  );
}

/* ========================================
   Mobile Menu Toggle
   ======================================== */

class MobileMenu extends FFElement {
  connectedCallback() {
    this.toggle = this.qs('[data-menu-toggle]');
    this.drawer = this.qs('[data-menu-drawer]');
    this.overlay = this.qs('[data-menu-overlay]');
    this.close = this.qs('[data-menu-close]');

    if (this.toggle) this.toggle.addEventListener('click', () => this.open());
    if (this.close) this.close.addEventListener('click', () => this.shut());
    if (this.overlay) this.overlay.addEventListener('click', () => this.shut());
  }

  open() {
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    this.toggle.setAttribute('aria-expanded', 'true');
  }

  shut() {
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    this.toggle.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('mobile-menu', MobileMenu);

/* ========================================
   Cart Drawer
   ======================================== */

class CartDrawer extends FFElement {
  connectedCallback() {
    this.overlay = this.qs('[data-cart-overlay]');
    this.closeBtn = this.qs('[data-cart-close]');

    if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());

    document.addEventListener('cart:open', () => this.open());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
    });
  }

  open() {
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.qs('[data-cart-close]')?.focus();
  }

  close() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async refresh() {
    const cart = await CartAPI.get();
    dispatchCartUpdate(cart);
    const res = await fetch('/?section_id=cart-drawer');
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newContent = doc.querySelector('[data-cart-drawer-content]');
    if (newContent) {
      this.qs('[data-cart-drawer-content]').innerHTML = newContent.innerHTML;
    }
  }
}

customElements.define('cart-drawer', CartDrawer);
